export default __webpack_public_path__ + "static/media/tutorial-image-four.cdb5f1a6.png";